// Check https://nextjs.org/docs/basic-features/environment-variables

export const environments = {
    // api_endpoint: 'http://localhost:3000', // LOCAL
    // api_endpoint: 'https://api.alquileresonline.pro/', // PROD
    api_endpoint: process.env.NEXT_PUBLIC_API_ENDPOINT,
    render_endpoint: 'http://render.zenrise.io/zen/'
};
